<template>
  <div class="flex flex-col gap-1 border border-[#d47c84] cursor-pointer rounded-md p-2" @click="model = true">
    <niceone-image :src="$publicPath(tamaraLogo)" width="46"/>

    <div class="flex items-end">
      <slot name="description"></slot>
      <van-icon class="flip-icon" name="arrow"/>
    </div>

  </div>

  <responsive-model v-model="model" :style="{ height: $device.isDesktop ? '500px' : '100%'  }" closeable hide-action-btn
                    size="md">
    <div class="h-full pt-5 sm:pt-0">
      <iframe
          :src="`https://cdn.tamara.co/widget-v2/tamara-widget.html?lang=${$i18n.locale}&public_key=dd0e893a-627b-11eb-a5ac-02001700e43e`"
          height="100%"
          title="Tamara Payment Info"
          width="100%"
      />
    </div>
  </responsive-model>
</template>

<script setup>
import ResponsiveModel from "@/components/common/dialogs/responsive";

defineProps({
  price: {
    type: Number,
    default: 0
  }
})

const {locale} = useI18n()
const tamaraLogo = `/images/payment/tamara-${locale.value}.png`

const model = ref(false)
</script>